export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-010_tn.7e17deb6.jpg";